<template>
  <div class="font" >
    <b-container class='mt-4 px-0'>
      <b-row>
        <b-col cols='12' class='mx-auto mt-4 ml-3 font-org-right-blue'>
          <h4><b-icon icon="files" class='mr-2'></b-icon>求人詳細</h4>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols='7' class='mx-auto'>
          <b-row class='mt-4 pb-2'>
            <b-col cols="2" class='ml-auto text-right px-0'>
              <router-link :to="'./edit'">
                <b-button pill class='table-edit-button'>編集する</b-button>
              </router-link>
            </b-col>
            <b-col cols='px-0' class='mr-auto'>
              <router-link :to="'/organization/matchList'" >
                <b-button pill class='table-edit-button'> この求人の応募者を見る </b-button>
              </router-link>
            </b-col>
          </b-row>

          <b-row class='mt-2 border-orange p-4'>
            <b-col cols='12' class='px-0 border-bottom-gray pb-2'>
              <h4> {{ jobInfo.title }} </h4>
              {{ companyInfo.name }} - {{ companyInfo.address1 }} {{ companyInfo.address2 }}<br>
              ￥{{ min_salary }} 〜 ￥{{ max_salary }} ( {{ salaryOptions[jobInfo.employment_form] }})
            </b-col>
            <b-col cols='12' class='px-0 mt-3'>
              <label >仕事内容及びアピールポイント : </label><br>
              <label >{{ jobInfo.title }} </label><br>

              <label >職務経験 : </label><br>
              <label >{{ jobInfo.title }} </label><br>

            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
  components: {
  },
  data() {
    return{
      idToken: localStorage.idToken,
      jobId: this.$route.params.jobId,
      companyInfo: {},
      jobInfo: [],
      emStatusOptions: {
        full: this.$i18n.t('message.full_time_employee'),
        part: this.$i18n.t('message.part_time_job'),
        temporary: this.$i18n.t('message.temporary_staff'),
        contract: this.$i18n.t('message.contract_employee')
      },
      publicOptions: {
        public: this.$i18n.t('message.public'),
        private: this.$i18n.t('message.private')
      },
      min_salary: '',
      max_salary: '',
      start_time: '',
      end_time:'',
      salaryOptions: {
        'hourt': '時給' ,
        'week': '週給',
        'month': '月給' ,
        'year': '年収' ,
      },
    }
  },
  mounted(){
    this.$store.dispatch("staff/fetchStaff", this.idToken)
    axios
    .get(process.env.VUE_APP_API + "/api/org/jobs/" + this.jobId, {headers: {'Authorization': 'Bearer ' + this.idToken}})
    .then(response => {
      this.jobInfo = response.data

      var salary_list = response.data.salary.split('~')
      this.min_salary = salary_list[0]
      this.max_salary = salary_list[1]
      var working_hours_list = response.data.working_hours.split('~')
      this.start_time = working_hours_list[0]
      this.end_time = working_hours_list[1]
    }).catch(error => {
      console.log('this is org error', error)
    })

    if(this.staff != null){
      axios
      .get(process.env.VUE_APP_API + "/api/org/organizations/" + this.staff.organization_id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        console.log(response.data)
        this.companyInfo = response.data.organization
        this.$store.commit('setLoading', false)
      }).catch(error => {
        console.log('this is org error', error)
      })
    }
    this.$store.commit('setLoading', false)
  },
  computed: {
    ...mapGetters({
      staff:'staff/getStaff',
    })
  },
  watch: {
    staff: function(){
      axios
      .get(process.env.VUE_APP_API + "/api/org/organizations/" + this.staff.organization_id, {headers: {'Authorization': 'Bearer ' + this.idToken}})
      .then(response => {
        this.companyInfo = response.data.organization
        this.$store.commit('setLoading', false)
      }).catch(error => {
        console.log('this is org error', error)
      })
    }
  }
}

</script>
<style type="scss" scoped="">
.border-orange{
  border: 2px solid orange;
  border-radius: 1rem;
}
</style>
